import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SharedService } from './services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    public sharedService: SharedService,
    private router: Router,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event) {
          this.sharedService.getCurrentUserDetails(event.url);
          this.sharedService.closeToaster();
        }
      }
    });
  }

  ngOnInit(): void {
    document.title = this.sharedService.siteName;
    if (window.location.pathname != '/login') {
      this.sharedService.setLogOutTimer();
    }
  }

}


